export function getRouteStopLinkTestId(label: string) {
  return `ChangeHistory::ChangedValues::RouteDetails::RouteLink::${label}`;
}
